const TARGET_MAX_BYTES = 2 * 1024 * 1024;
const MAX_INPUT_BYTES = 20 * 1024 * 1024;
const TARGET_DATA_URL_LENGTH = Math.floor((TARGET_MAX_BYTES * 4) / 3);

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(image);
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Could not read the image file.'));
    };

    image.src = objectUrl;
  });
}

function renderCompressedDataUrl(image, maxDimension, quality) {
  const largestSide = Math.max(image.width, image.height, 1);
  const scale = Math.min(1, maxDimension / largestSide);
  const width = Math.max(1, Math.round(image.width * scale));
  const height = Math.max(1, Math.round(image.height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Could not process the image.');
  }

  context.drawImage(image, 0, 0, width, height);
  return canvas.toDataURL('image/jpeg', quality);
}

export function compressImageToDataUrl(file, { maxDimension = 2048 } = {}) {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No file selected.'));
      return;
    }

    if (!file.type.startsWith('image/')) {
      reject(new Error('Please choose an image file.'));
      return;
    }

    if (file.size > MAX_INPUT_BYTES) {
      reject(new Error('Image must be under 20 MB.'));
      return;
    }

    loadImageFromFile(file)
      .then((image) => {
        let dimension = maxDimension;
        let quality = 0.92;
        let dataUrl = renderCompressedDataUrl(image, dimension, quality);

        while (dataUrl.length > TARGET_DATA_URL_LENGTH) {
          if (quality > 0.35) {
            quality = Math.max(0.35, quality - 0.07);
            dataUrl = renderCompressedDataUrl(image, dimension, quality);
            continue;
          }

          if (dimension > 240) {
            dimension = Math.max(240, Math.round(dimension * 0.82));
            quality = 0.85;
            dataUrl = renderCompressedDataUrl(image, dimension, quality);
            continue;
          }

          break;
        }

        if (dataUrl.length > TARGET_DATA_URL_LENGTH) {
          reject(new Error('Could not compress this image under 2 MB. Try a simpler photo.'));
          return;
        }

        resolve(dataUrl);
      })
      .catch(reject);
  });
}

export function readImageFile(file) {
  return compressImageToDataUrl(file, { maxDimension: 2048 });
}

export function readAvatarImage(file) {
  return compressImageToDataUrl(file, { maxDimension: 1024 });
}

export function promptImageUrl() {
  const url = window.prompt('Enter image URL:');
  if (!url) return null;

  const trimmed = url.trim();
  if (!/^https?:\/\//i.test(trimmed)) {
    window.alert('Please enter a valid http or https URL.');
    return null;
  }

  return trimmed;
}
